document.addEventListener('turbolinks:load', () => {
  const toggle = document.querySelector('.navbar-toggler')
  const collapse = document.querySelector('.navbar-collapse')

  toggle.addEventListener('click', () => {
    collapse.classList.toggle('collapse')
  }, { capture: false })
})
